module.exports = __webpack_public_path__ + "static/media/Levin_Range_Stool Clone.d1b23ca2.jpg";